import { ComponentRef, Injectable } from '@angular/core';
import { IUserSwitchCustomerDialogService } from 'shared/interfaces/services/dialogs/user-switch-customer-dialog-service.abstract';
import { DialogBaseService } from 'projects/shared/lib/services/ui/dialog.service';
import { UserSwitchCustomerDialogComponent } from 'projects/shared/lib/components/shared/user/switch-customer-dialog/user-switch-customer-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class UserSwitchCustomerDialogService implements IUserSwitchCustomerDialogService {

  userSwitchCustomerDialogShow(
    callbackCancel: () => void,
  ): void {

    DialogBaseService.dialogGenericShow(
      UserSwitchCustomerDialogComponent,
      (componentRef: ComponentRef<UserSwitchCustomerDialogComponent>) => {
        let component = componentRef.instance;

        component.modalCancel.subscribe(
          () => {
            callbackCancel();
            DialogBaseService.dynamicComponentRemove(componentRef);
          }
        );

      }
    );
  }

}
